import React from "react";

const dangerousTags = /<\/?(script|iframe|object|embed|form|input|button|textarea|select|meta|link|base|svg|math)[^>]*>/gi;
const eventHandlers = /\son[a-z]+\s*=\s*(['"]).*?\1/gi;
const javascriptUrls = /\s(href|src)\s*=\s*(['"])\s*javascript:[^'"]*\2/gi;
const dangerousStyles = /\sstyle\s*=\s*(['"])[^'"]*(expression|javascript:)[^'"]*\1/gi;

export function sanitizeHtml(html) {
  if (!html) {
    return "";
  }

  return String(html)
    .replace(dangerousTags, "")
    .replace(eventHandlers, "")
    .replace(javascriptUrls, "")
    .replace(dangerousStyles, "")
    .trim();
}

function renderBrandInline(line, keyPrefix) {
  const tokens = line.split(/(<span>.*?<\/span>)/gi).filter(Boolean);

  return tokens.map((token, index) => {
    const spanMatch = token.match(/^<span>(.*?)<\/span>$/i);
    if (spanMatch) {
      return <span key={`${keyPrefix}-span-${index}`}>{spanMatch[1]}</span>;
    }

    const plainText = token.replace(/<\/?[^>]+>/g, "");
    return <React.Fragment key={`${keyPrefix}-text-${index}`}>{plainText}</React.Fragment>;
  });
}

export function renderBrandMarkup(brand) {
  const cleaned = sanitizeHtml(brand).replace(/^<p>|<\/p>$/gi, "");
  const lines = cleaned.split(/<br\s*\/?>/i).map((line) => line.trim()).filter(Boolean);

  return lines.map((line, index) => (
    <React.Fragment key={`brand-line-${index}`}>
      {renderBrandInline(line, `brand-${index}`)}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
}

export function isNumericId(value) {
  return /^\d+$/.test(String(value ?? "").trim());
}
